/**
 * ErrorMessage Component
 * Displays error messages with optional retry button
 */

import React from 'react';
import { Box, Alert, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

export const ErrorMessage = ({ error, onRetry }) => {
  const message = error?.response?.data?.message || error?.message || 'An error occurred';

  return (
    <Box sx={{ p: 2 }}>
      <Alert
        severity="error"
        action={
          onRetry && (
            <Button
              color="inherit"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={onRetry}
            >
              Retry
            </Button>
          )
        }
      >
        {message}
      </Alert>
    </Box>
  );
};
